var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ApplicationPage = (function (_super) {
    __extends(ApplicationPage, _super);
    function ApplicationPage() {
        var _this = _super.call(this) || this;
        _this.DEFAULT_HTML_EDITOR_MODE = "Advance";
        return _this;
    }
    ApplicationPage.prototype.initialize = function () {
        var _this = this;
        _super.prototype.initialize.call(this);
        $("[data-delete-subform-server-side]").off("click.delete-subform").on("click.delete-subform", function (e) { return _this.deleteSubFormServerSide(e); });
        this.enableFloatingPanelLayouts();
        this.overrideNumberValidation();
        this.removeUselessZeros();
        this.showSwiftPreview();
        this.fixIELayout();
    };
    ApplicationPage.prototype.cleanUpNumberField = function (field) { };
    ApplicationPage.prototype.closeModal = function (refreshParent) {
        if (refreshParent === void 0) { refreshParent = false; }
        this.isClosingModal = true;
        if (this.currentModal) {
            if (refreshParent)
                this.refresh();
            this.currentModal.modal('hide').remove();
            this.currentModal = null;
            PubSub.publish("modal:close");
        }
        else if (window.parent) {
            var p = window.parent;
            if (p.page)
                p.page.closeModal(refreshParent);
        }
        this.isClosingModal = false;
        return true;
    };
    ApplicationPage.prototype.getModalTemplate = function (options) {
        var modalDialogStyle = "";
        var iframeStyle = "width:100%; border:0;";
        var iframeAttributes = "";
        if (options) {
            if (options.width) {
                modalDialogStyle += "width:" + options.width + ";";
            }
            if (options.height) {
                modalDialogStyle += "height:" + options.height + ";";
                iframeStyle += "height:" + options.height + ";";
                iframeAttributes += " data-has-explicit-height='true'";
            }
        }
        return "<div class='modal fade' id='myModal' tabindex='-1' role='dialog' aria-labelledby='myModalLabel'\
 aria-hidden='true'>\
            <div class='modal-dialog' style='" + modalDialogStyle + "'>\
    <div class='modal-content'>\
        <button type='button' class='close' data-dismiss='modal' aria-label='Close'></button>\
    <div class='modal-body'>\
        <div class='row text-center'><i class='fa fa-spinner fa-spin fa-2x'></i></div>\
        <iframe style='" + iframeStyle + "' " + iframeAttributes + "></iframe>\
    </div>\
</div></div></div>";
    };
    ApplicationPage.prototype.deleteSubFormServerSide = function (event) {
        var button = $(event.currentTarget);
        var container = button.parents(".subform-item");
        container.find("input[name*=MustBeDeleted]").val("true");
        container.hide();
        this.updateSubFormStates();
        event.preventDefault();
        this.invokeActionWithAjax(event, button.data("change-action"));
    };
    ApplicationPage.prototype.enableFloatingPanelLayouts = function () {
        var _this = this;
        var layoutContainer = this.getLayoutContainer();
        if (layoutContainer.length === 0) {
            return;
        }
        if (layoutContainer.length > 1) {
            console.error("Currently only support one floating panel layout per page");
            return;
        }
        $(window).scroll(function (event) {
            var y = $(window).scrollTop() + 15;
            var panel = $('.floating-panel-layout-panel');
            var fixedClass = 'floating-panel-layout-panel--fixed';
            var scrollReachedClass = 'floating-panel-layout-panel--scroll-maximum-reached';
            var containerTop = _this.calculateContainerDimensions().top;
            var containerBottom = _this.calculateContainerDimensions().bottom;
            if (y >= containerTop) {
                var panelHeight = panel.height();
                var panelBottom = y + panelHeight;
                if (panelBottom > containerBottom) {
                    panel.addClass(scrollReachedClass);
                    panel.removeClass(fixedClass);
                }
                else {
                    panel.addClass(fixedClass);
                    panel.removeClass(scrollReachedClass);
                }
            }
            else {
                panel.removeClass(fixedClass);
            }
        });
    };
    ApplicationPage.prototype.calculateContainerDimensions = function () {
        var layoutContainer = this.getLayoutContainer();
        var containerTop = layoutContainer.offset().top;
        var containerBottom = layoutContainer.height() + containerTop;
        return {
            top: containerTop,
            bottom: containerBottom
        };
    };
    ;
    ApplicationPage.prototype.getLayoutContainer = function () {
        return $('.floating-panel-layout-container');
    };
    ApplicationPage.prototype.overrideNumberValidation = function () {
        $("[data-big-number]").on("keyup change focus", function (event) {
            if (event.type == "change" || event.type == "focus" || event.key.length === 1 || event.which === 8 || event.which === 46) {
                var result = $(event.target).val()
                    .replace(/\s/g, '')
                    .replace(/\,/g, '');
                if (result == "")
                    return;
                var wholeNumber = result.split(".")[0];
                var fraction = result.split(".")[1];
                if (fraction == "" || fraction == undefined)
                    result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                else
                    result = wholeNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + "." + fraction;
                $(event.target).val(result);
            }
        });
        $("[data-big-number]").on("blur", function (event) {
            var val = $(event.target).val().replace(/\s/g, '').replace(/\,/g, '');
            $(event.target).val(val);
        });
        var methods = $.validator.methods;
        methods.range = function (value, element, param) {
            var globalizedValue = value.replace(/\s/g, '').replace(/\,/g, '');
            return this.optional(element) || (globalizedValue >= param[0] && globalizedValue <= param[1]);
        };
    };
    ApplicationPage.prototype.removeUselessZeros = function () {
        $("[data-val-number]").each(function (index, element) {
            var decimalValue = $(element);
            decimalValue.val(eval(decimalValue.val()));
        });
    };
    ApplicationPage.prototype.showSwiftPreview = function () {
        var contextId = this.getUrlParameter('showswiftpreviewmodal');
        var url = "/kroll-user/swift-message-preview?context=" + contextId;
        if (contextId != null)
            this.openModal(url, this.toJson('{"height":"600px"}'));
    };
    ApplicationPage.prototype.getUrlParameter = function (sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)), sURLVariables = sPageURL.split('&'), sParameterName, i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };
    ApplicationPage.prototype.fixIELayout = function () {
        var msie = window.navigator.userAgent.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            $('.ie-sticky-footer').css("display", "flex");
            $('.main').css("display", "block");
            var pageHeight = $(".main").data("page-height");
            var mainHeight = pageHeight ||
                ($('.header-container').outerHeight() + $('.top-separator').outerHeight()
                    + $('.content-container').outerHeight() + $('footer').outerHeight());
            $('.main').css("display", "flex");
            $('.main').css("height", mainHeight.toString());
        }
    };
    ApplicationPage.prototype.executeAction = function (action, trigger) {
        if (action.UpdateLabel) {
            this.updateLabel(action.UpdateLabel, action.NewValue);
            return true;
        }
        return _super.prototype.executeAction.call(this, action, trigger);
    };
    ApplicationPage.prototype.updateLabel = function (controlId, newValue) {
        $("#" + controlId).val(newValue);
    };
    return ApplicationPage;
}(BaseApplicationPage));
page = new ApplicationPage();
//# sourceMappingURL=application.page.js.map